var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-gallery"},[_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.gallery),function(slide){return _c('swiper-slide',{key:slide.id},[_c('img',{attrs:{"src":slide,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }